<template>
	<div class="" :class="{hide: !isShow}">
		<div class="van-overlay" style="z-index: 2001;" @click="handleCancel" ></div>
		<div class="van-popup van-popup--bottom" style="z-index: 2002;">
			<div class="van-picker van-area">
				<div class="van-hairline--top-bottom van-picker__toolbar">
					<button type="button" class="van-picker__cancel" @click="handleCancel" >取消</button>
					<button type="button" class="van-picker__confirm" @click="handleConfirm">确认</button>
				</div>
				<!---->
				<div class="van-picker__columns" style="height: 220px;" ref="listInnerRef">
					<div class="van-picker-column">
						<ul
							class="van-picker-column__wrapper"
							style="line-height: 44px;padding-top: 88px;box-sizing: border-box;"
							@touchmove="handleMove"
							@touchstart="handleStart(0, $event)"
							@touchend="handleEnd"
							@touchcancel="handleEnd"
						>
							<li role="button" v-for="(item,index) in areaList" :key="index"  :data-val="item.text" class="van-ellipsis van-picker-column__item van-picker-column__item--selected" style="height: 44px;">
								{{item.text}}
							</li>
						</ul>
					</div>
					<div class="van-picker-column">
						<ul
							class="van-picker-column__wrapper"
							style="line-height: 44px;padding-top: 88px;box-sizing: border-box;"
							@touchmove="handleMove"
							@touchstart="handleStart(1, $event)"
							@touchend="handleEnd"
							@touchcancel="handleEnd"
						>
							<li role="button" v-for="(item,index) in areaList[provinceIndex].children" :data-val="item.text"  :key="index"  class="van-ellipsis van-picker-column__item van-picker-column__item--selected" style="height: 44px;">
							{{item.text}}
							</li>
						</ul>
					</div>
					<div class="van-picker-column" >
						<ul
							class="van-picker-column__wrapper"
							style="line-height: 44px; padding-top: 88px;box-sizing: border-box;"
							@touchmove="handleMove"
							@touchstart="handleStart(2, $event)"
							@touchend="handleEnd"
							@touchcancel="handleEnd"
						>

							<li role="button" v-for="(item,index) in areaList[provinceIndex].children[cityIndex].children" :data-val="item.text" :key="index"   class="van-ellipsis van-picker-column__item van-picker-column__item--selected" style="height: 44px;">
								{{item.text}}
							</li>
						</ul>
					</div>
					<div class="van-picker__mask" style="background-size: 100% 88px;"></div>
					<div class="van-hairline-unset--top-bottom van-picker__frame" style="height: 44px;"></div>
				</div>
				<!---->
			</div>
		</div>
	</div>
</template>
<script>
	import { css, MTween } from './MTween.js';
	import  areaList from '@/assets/areaR.js';
	let touch = { lastTime: 0, interval: 300 };
	let areaListnowIndex=''
	export default {

	    props: {
	        name: {
	            type: String,
	            default: ''
	        },
			linkageVal: {
			  type: Array,
			  default() {
			    return [null, "拉萨市", "市辖区"];
			  }
			},
			isShow: {
			  type: Boolean,
			  default: true
			}
	    },
	    name: 'iconfont',
	    data() {
	        return {
				areaList:areaList,
				provinceIndex:0,
				cityIndex:0,
				areaIndex:0
			}
	    },
	    methods: {
			handleConfirm() {
			    let sss = this.handleResult();
			    console.log(sss,'sssss')
			  this.$emit('emitConfirm', sss);
			},
			handleCancel() {
			  this.$emit('emitCancel', this.handleResult());
			},
			handleInitPos() {
			  if (!this.initVal.length) {
			    return;
			  }

			  let aPos = this.list.map((item, index) =>
			    item.findIndex(obj => obj.val === this.initVal[index])
			  );

			  if (aPos.includes(-1)) {
			    throw Error('初始化失败，请核对数据有效性');
			  }

			  [...this.$refs.listInnerRef.children].forEach((item, index) => {
			    let val = -css(item.children[0], 'height') * aPos[index];
			    css(item, 'translateY', val);
			  });

			  this.$emit('emitInit', { index: aPos, _: 'index-初始化索引' });
			},
	       handleMove(e) {
	         if (!touch.init) {
	           return;
	         }

	         touch.diffY = e.changedTouches[0].pageY - touch.startY;
	         touch.dir = touch.diffY < 0 ? 'up' : 'down';

	         css(touch.el, 'translateY', touch.oldVal + touch.diffY);
	       },
		   handleStart(elIndex, e) {
		     let now = +new Date();
		     if (now - touch.lastTime < touch.interval) {
		       return (touch.init = false);
		     }
		     touch.init = true;
		     touch.lastTime = now;
		     touch.elIndex = elIndex;
		     touch.el = this.$refs.listInnerRef.children[elIndex].children[0];
		     touch.diffY = 0;
		     touch.startY = e.changedTouches[0].pageY;
			 [...this.$refs.listInnerRef.children].forEach((item, index) => {
				if(elIndex< index &&item.children[0]){
					css(item.children[0], 'translateY',0);
				}
			 });
//			 if(elIndex==0){this.provinceIndex=0;this.cityIndex=0;this.areaIndex=0}
//			 if(elIndex==1){this.cityIndex=0;this.areaIndex=0}
//			 if(elIndex==2){this.areaIndex=0}
			 touch.oldVal = css(touch.el, 'translateY');
		   },
		   handlePrevent(e) {
		     e.preventDefault();
		   },
		   handleEnd() {
		     if (!touch.init) {
		       return;
		     }
		     let el = touch.el;
		     let height = css(el.children[0], 'height');
		     let maxHeight = height * (el.children.length - 1);
		     let targetY = css(el, 'translateY');

		     if (touch.dir === 'up') {
		       targetY -= (targetY % height) + height;
		     } else {
		       targetY -= targetY % height;
		     }

		     // 超过每项高度的1/3才滑动，否则还原位置
		     if (Math.abs(touch.diffY) < height / 3) {
		       targetY = touch.oldVal;
		     }

		     if (targetY > 0) {
		       targetY = 0;
		     } else if (targetY < -maxHeight) {
		       targetY = -maxHeight;
		     }

		     MTween({
		       el,
		       target: { translateY: targetY },
		       type: 'easeOut',
		       time: 100,
		       callBack: () => this.$emit('emitOver', this.handleResult(touch.elIndex))
		     });
		   },
		   handleResult(elIndex = -1) {
		      let obj = {
		        bool: true,
		        provinceId: [],
		        meta: [],
		        val: [],
		        _: 'bool-是否正常,index-最终索引,meta-最终数据,val-最终结果'
		      };


		      [...this.$refs.listInnerRef.children].forEach((item, index) => {
		        let msg = '111';
				if(item.children[0]){
					let children= item.children[0].children;
					let nowIndex = Math.abs(
					  css(item.children[0], 'translateY') / css(children[0], 'height')
					);
					let areaListContent=[]
					if(index==0){
						this.provinceIndex=nowIndex;
						areaListContent=this.areaList[nowIndex]
					}
					if(index==1){
						this.cityIndex=nowIndex;
						areaListContent=this.areaList[this.provinceIndex].children[this.cityIndex]
					}
					if(index==2){
						this.areaIndex=nowIndex;
						areaListContent=this.areaList[this.provinceIndex].children[this.cityIndex].children[this.areaIndex]
					}
					if (children[nowIndex]) {
					  obj.provinceId.push(areaListContent.value);
					  obj.meta.push(areaListContent);
					  obj.val.push(areaListContent.text);
					} else {
					  obj.provinceId.push(msg);
					  obj.meta.push(msg);
					  obj.val.push(msg);
					  obj.bool = false;
					}
				}

		      });
			  console.log(obj)
		      if (elIndex !== -1) {
		        obj.which = elIndex;
		        obj._ =
		          'bool-是否正常,index-联动前索引,meta-联动前数据,val-联动前结果,which-联动前操作列索引';
		      }

		      return obj;
		    },
	    },

		computed: {

	    }
	}
</script>

<style>
	.van-overlay {
	    position: fixed;
	    top: 0;
	    left: 0;
	    z-index: 1;
	    width: 100%;
	    height: 100%;
	    background-color: rgba(0,0,0,.7);
	}
	.van-popup--bottom {
	    bottom: 0;
	    left: 0;
	    width: 100%;
	}
	.van-popup {
	    position: fixed;
	    max-height: 100%;
	    overflow-y: auto;
	    background-color: #fff;
	    -webkit-transition: -webkit-transform .3s ease-out;
	    transition: -webkit-transform .3s ease-out;
	    transition: transform .3s ease-out;
	    transition: transform .3s ease-out, -webkit-transform .3s ease-out;
	    transition: transform .3s ease-out,-webkit-transform .3s ease-out;
	    -webkit-overflow-scrolling: touch;
	}
	.van-picker {
	    position: relative;
	    background-color: #fff;
	    -webkit-user-select: none;
	    user-select: none;
	    -webkit-text-size-adjust: 100%;
	}
	.van-picker__toolbar {
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: flex;
	    -webkit-box-pack: justify;
	    -webkit-justify-content: space-between;
	    justify-content: space-between;
	    height: 44px;
	    line-height: 44px;
	}


</style>
